import React, {Fragment, useEffect, useState, useRef} from 'react';
import {Section, Popup, Text, Info} from '../../../components';
import Sending_limits_update_popup from './';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import AddIcon from '@material-ui/icons/Add';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import {Form, Field} from 'react-final-form';

import axios from 'axios';
import { makeStyles } from '@material-ui/core/styles';
import {connect} from 'react-redux';


const useStyles = makeStyles((theme) => ({
  link:{color:theme.palette.tertiary.main},
  error:{color:theme.palette.error.main}
}));


function Marketing_email_section(props){
  const classes=useStyles();
  const [sending_limits_popup, setSendingLimitsPopup]=useState(undefined);
  const [marketing_domain_setup_popup, setMarketingDomainSetupPopup]=useState(undefined);

  return(
      <Fragment>
      {(props.workspace==undefined)?null:
        <Section title={<Typography color='primary' style={{position:'relative', fontWeight:'bold', fontSize:'14px', marginTop:'5px'}}><span>Marketing email</span><span><Info name='marketing_email_setup'/></span></Typography>} icon={<img style={{height:'30px'}} src='/images/marketing_email.png'/>} maxWidth='600px' action={<div style={{cursor:'pointer'}} onClick={()=>{setMarketingDomainSetupPopup('NEW');}}><AddIcon color='primary' style={{fontSize:'20px', marginLeft:'20px'}}/></div>}>
        <Marketing_domain verification_status="Verification status" domain_name="Domain" limits={'Sending limits (click to edit)'} title_line />
        <hr style={{marginTop:'-2px'}}/>

        </Section>
      }
      {(marketing_domain_setup_popup!=undefined)?<Marketing_domain_setup_popup {...props} marketing_domain_login_id={marketing_domain_setup_popup} handleClose={()=>{setMarketingDomainSetupPopup(undefined);}}/>:null}
      </Fragment>
  )
}


//{props.workspace.marketing_email_domains.map(function(smtp){ //100 daily - 45 hourly - 60 seconds
//  return(<div style={{position:'relative'}}>
//  <div style={{position:'absolute', top:'0px', right:'30px'}}>{(smtp.error_login==true)?<ErrorIcon color='error' style={{fontSize:'20px', cursor:'pointer'}} onClick={()=>{setSmtpSetupPopup(smtp.id);}}/>:(smtp.authentication=='OAUTH')?null:<EditIcon color='primary' style={{fontSize:'20px', cursor:'pointer'}} onClick={()=>{setSmtpSetupPopup(smtp.id);}}/>}</div><div style={{position:'absolute', top:'0px', right:'5px'}}><DeleteIcon style={{fontSize:'20px', color:'#bdbdbd', cursor:'pointer'}} //onClick={()=>{setSmtpDeletePopup(smtp.id);}}/></div><Smtp id={smtp.id} username={smtp.username} limits={smtp.daily_limit+' daily - '+smtp.hourly_limit+' hourly - '+smtp.seconds_delay+' seconds'} setSendingLimitsPopup={()=>{setSendingLimitsPopup(smtp);}} smtp={(smtp.provider=='outlook_api')?'API':(smtp.smtp_server+':'+smtp.smtp_port)} imap={(smtp.provider=='outlook_api')?'API':(smtp.imap_server+':'+smtp.imap_port)} send_folder={smtp.send_folder} //provider={(smtp.provider=='outlook_api')?'outlook':smtp.provider}/></div>)
//})}


function Marketing_domain(props){
  const classes=useStyles();
  let tooltip="Tooltip"
  return(
  <Typography variant='caption'>
        <Tooltip title={tooltip}>
        <Grid container>
              <Grid item xs={4} sm={4} style={{fontWeight:(props.title_line==true)?'bold':undefined, position:'relative',overflowX:'hidden'}}><span style={{position:'relative'}}>{props.domain_name}</span></Grid>
              <Grid item xs={5} sm={5} style={{overflowX:'hidden', whiteSpace:'nowrap', width:'calc(100% - 10px)', fontWeight:(props.title_line==true)?'bold':undefined}}>{(props.title_line==true)?props.limits:<span className={classes.link} style={{textDecoration:'underline', cursor:'pointer'}} onClick={()=>{props.setSendingLimitsPopup()}}>{props.limits}</span>}</Grid>
              <Grid item xs={3} sm={3} style={{overflowX:'hidden', whiteSpace:'nowrap', width:'calc(100% - 10px)', fontWeight:(props.title_line==true)?'bold':undefined}}>{props.verification_status}</Grid>
        </Grid>
        </Tooltip>
 </Typography>
)}


export default connect(ss, dd)(Marketing_email_section);

function ss(state){
  return{}
}

function dd(dispatch){
  return{
    createMarketingDomain:(params)=>{dispatch({type:'REQUEST_CREATE_MARKETING_DOMAIN', payload:params})}
  }
}


function Marketing_domain_setup_popup(props){

  function onSubmit(params){
    props.createMarketingDomain(params);
  }

  return(
    <Form
      onSubmit={onSubmit}
    >
      {form_props => (
        <form onSubmit={form_props.handleSubmit}>
        <Popup handleClose={props.handleClose} accept_button='Save' accept_button_click={()=>{form_props.form.submit(); form_props.form.reset(); props.handleClose();}}  always_open title='Marketing email domain setup' content={
          <Grid container>
            <Grid item xs={8}><div style={{marginTop:'30px'}}><Text title='Domain' name='domain_name'/></div></Grid>
            <Grid item xs={12}><div style={{marginTop:'20px', marginBottom:'20px'}}><Typography variant='caption' style={{width:'calc(100% - 20px)', marginLeft:'10px'}}>Once you add a domain you have ..as.df.safd.as.f.s af.asf. s.df.saf .s.df.sf sfsaf</Typography></div></Grid>
          </Grid>
        }/>
        </form>
      )}
    </Form>
  );
}
